import { IOrder } from '../orders/types'
import { ResponseArray } from '../types'

export interface ICustomerResourcePermission {
  Id: string;
  ResourceId: string;
  UserId: number;
  ResourceName: string;
}

export interface ICustomerResourcePermissionRequest {
  Id: string;
  CustomerNumber: string;
  CustomerName: string;
  UserEmail: string;
  UserId: number;
  Status: number;
  RejectionReason: string
}

export interface ICustomerSalesRepresentative {
  Name: string;
  SalesRepNumber: string;
}

export interface ICustomer {
  CustomerNumber: string
  CustomerName: string
  CustomerSalesText: string[]
  CustomerShippingText: string[]
  IsCreditBlocked?: boolean
  CreditLimit?: number
  TotalReceivables?: number
  CustomerAddress: IAddress
  Orders: IOrder[]
  Permissions: ICustomerResourcePermission[];
  PendingPermissionRequests: ICustomerResourcePermissionRequest[];
  SalesReps: ICustomerSalesRepresentative[];
  PaymentTerm: string
  DivisionCode?: string
  DivisionText?: string
}

export interface ICustomerContact {
  UserId: number
  Fullname: string
  Email: string
}

export interface IAddress {
  Name1: string
  Street: string
  Name2: string
  City: string
  Region: string
  PostalCode: string
  Phone: string
  Country: string
  Emails?: IAddressEmail[]
  FirstName?: string
  LastName?: string
  TaxJurisdictionCode?: string
}

export interface IAddressEmail {
  AddressNumber: string
  SequenceNumber: string
  FlagDefault: boolean
  FlagNoUse: boolean
  FlagHome: boolean
  Email: string
}

export default interface State {
  activeCustomer: ICustomer,
  customers: ResponseArray<ICustomer>,
  shipTos: ResponseArray<ICustomer>,
  error: string,
  loading: boolean,
  searchFilters: ICustomerSearchFilter,
  customerContacts: ICustomerContact[],
}

export interface ICustomerFilterOn {
  CustomerNumber: boolean,
  CustomerName: boolean,
  PermissionRequests: boolean,
  Users: boolean,
}

export interface ICustomerFilter {
  CustomerNumber: string,
  CustomerName: string,
  PermissionRequests: boolean,
  Users: boolean,
  City: string,
  State: string,
  PostalCode: string,
}

export const blankFilter: ICustomerFilter = {
  CustomerNumber: '',
  CustomerName: '',
  PermissionRequests: false,
  Users: false,
  City: '',
  State: '',
  PostalCode: '',
}

export const blankFilterOn: ICustomerFilterOn = {
  CustomerNumber: false,
  CustomerName: false,
  PermissionRequests: false,
  Users: false,
}

export interface ICustomerSearchFilter {
  page: number
  sortBy: string
  sortDesc: boolean
  customerNumber: string
  customerName: string
  filterByHasUsers: boolean
  filterByHasPendingPermissions: boolean
  pageSize: 30
  city: string
  state: string
  postalCode: string
}
